/* eslint-disable no-console */
const validateByType = (type, val) => {
  // console.log(`${type}, ${val}`);
  let status;
  switch (type) {
    case 'text':
      status = val !== '';
      break;
    case 'phone':
      status = new RegExp(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/).test(val);
      break;
    case 'zipcode':
      status = new RegExp(/(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$)/).test(val);
      break;
    case 'email':
      /* eslint-disable no-useless-escape */
      status = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(val);
      /* eslint-enable no-useless-escape */
      break;
    case 'password':
      status = new RegExp(/^(?=.*[a-z])(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/).test(val); /* eslint-disable-line no-useless-escape */
      break;
    case 'productcode':
      // status = new RegExp(/^\d{7,8}[\.]\d{3}$/).test(val); /* eslint-disable-line no-useless-escape */
      // status = new RegExp(/^(\d{7,8}[\.]\d{3}$)|(^\d{7,8}$)/).test(val); /* eslint-disable-line no-useless-escape */
      status = new RegExp(/^(\d{1,}$)/).test(val); /* eslint-disable-line no-useless-escape */
      break;
    default:
      break;
  }
  return status;
};

// Format phone as xxx-xxx-xxxx
const formatPhone = (s) => {
  if (s !== null && s !== undefined && s !== '') {
    if (s.match(new RegExp(/\d/g) || []) !== null) {
      const arr = s.match(new RegExp(/\d/g) || []).join('');
      return `${arr.substring(0, 3)}-${arr.substring(3, 6)}-${arr.substring(6)}`;
    }
    return s;
  }
  return s;
};

const validate = (form) => {
  // Identify all fields with a validate attribute in form (will be on the label for the input/submit)
  const fieldList = form.querySelectorAll('[validate]');
  let field;
  let isValid;
  let required;
  let isFormValid = true;
  for (let i = 0; i < fieldList.length; i++) { /* eslint-disable-line no-plusplus */
    field = fieldList[i];
    isValid = true;
    required = field.getAttribute('required') !== null;
    // If value is required, run against validation OR
    if (required) {
      isValid = validateByType(field.getAttribute('validate'), field.value);
    }
    // If value isn't required but value has been entered that requires validation, then run
    if (!required && field.value !== '' && field.getAttribute('validate') !== 'text') {
      isValid = validateByType(field.getAttribute('validate'), field.value);
    }
    // Mark form as invalid
    if (!isValid) {
      isFormValid = isValid;
      // Toggle error class on element label
      form.querySelector(`[for="${field.id}"]`).parentNode.classList.add('ValidationFail');
    } else {
      form.querySelector(`[for="${field.id}"]`).parentNode.classList.remove('ValidationFail');
    }
  }
  return isFormValid;
};

const removeAllErrors = (form) => {
  const fieldList = form.querySelectorAll('[validate]');
  let field;
  for (let i = 0; i < fieldList.length; i++) { /* eslint-disable-line no-plusplus */
    field = fieldList[i];
    form.querySelector(`[for="${field.id}"]`).parentNode.classList.remove('ValidationFail');
  }
};

const addRequiredAttrs = (form) => {
  const inputList = form.querySelectorAll('.o-form__input');
  for (let i = 0; i < inputList.length; i++) { /* eslint-disable-line no-plusplus */
    inputList[i].setAttribute('required', 'required');
  }
};

const removeRequiredAttrs = (form) => {
  const inputList = form.querySelectorAll('.o-form__input');
  for (let i = 0; i < inputList.length; i++) { /* eslint-disable-line no-plusplus */
    inputList[i].removeAttribute('required');
  }
};

const clearInputValues = (form) => {
  const inputList = form.querySelectorAll('.o-form__input');
  for (let i = 0; i < inputList.length; i++) { /* eslint-disable-line no-plusplus */
    inputList[i].value = '';
  }
};

const positionWindowAtFormElement = (options) => {
  let position = 0;
  if (options.element) {
    position = $(options.element).offset().top;
  }
  if (options.position) {
    position = options.position; /* eslint-disable-line prefer-destructuring */
  }
  let offset = options.offset; /* eslint-disable-line prefer-destructuring */
  if (!offset) {
    offset = 0;
  }
  $('html, body').animate({
    scrollTop: position + offset,
  }, 250);
};

const disableFormSubmit = (form) => {
  if (!form) return;
  const submitBtn = form.querySelector('[type=submit]');
  if (!submitBtn) return;
  submitBtn.disabled = true;
  submitBtn.classList.add('updating');
};

const enableFormSubmit = (form) => {
  if (!form) return;
  const submitBtn = form.querySelector('[type=submit]');
  if (!submitBtn) return;
  submitBtn.disabled = false;
  submitBtn.classList.remove('updating');
};

const init = () => {};

export {
  addRequiredAttrs,
  clearInputValues,
  disableFormSubmit,
  enableFormSubmit,
  init,
  validate,
  formatPhone,
  positionWindowAtFormElement,
  removeAllErrors,
  removeRequiredAttrs,
  validateByType,
};
/* eslint-enable no-console */
